import Joi from "joi";
import {
  SOURCE_PAGE_TYPES,
  SECTIONS,
  SECTION_TYPES,
  CONTENT_TYPES,
} from "../constants";

export const blogPostViewed = Joi.object({
  sourceName: Joi.string()
    .valid(...Object.values(SECTIONS))
    .required(),
  sourcePage: Joi.string().required(),
  sourcePageType: Joi.string()
    .valid(...Object.values(SOURCE_PAGE_TYPES))
    .required(),
  sourceElement: Joi.string()
    .valid(...Object.values(SECTION_TYPES))
    .required(),
  contentType: Joi.string()
    .valid(...Object.values(CONTENT_TYPES))
    .required(),
  id: Joi.string().required(),
  title: Joi.string().required(),
});

export const activityViewed = Joi.object({
  sourceName: Joi.string().required(),
  sourcePage: Joi.string().required(),
  sourcePageType: Joi.string()
    .valid(...Object.values(SOURCE_PAGE_TYPES))
    .required(),
  sourceElement: Joi.string()
    .valid(...Object.values(SECTION_TYPES))
    .required(),
  contentType: Joi.string()
    .valid(...Object.values(CONTENT_TYPES))
    .required(),
  id: Joi.string().required(),
  title: Joi.string().required(),
});

export const leavingGoNoodleBumperViewed = Joi.object({
  title: Joi.string().required(),
  sourceName: Joi.string().required(),
  sourcePage: Joi.string(),
  sourcePageType: Joi.string().valid(...Object.values(SOURCE_PAGE_TYPES)),
  sourceElement: Joi.string()
    .valid(...Object.values(SECTION_TYPES))
    .required(),
  url: Joi.string().required(),
  optionSelected: Joi.string().required(),
});
